import React from "react";
import "./Closed.css";

import logo, { logoOnDark } from "../assets/logo.js";
import MailchimpSignup from "../components/MailchimpSignup";
import { useHomeVideo } from "../config/HomeVideos";

export default function ClosedPostDrop() {
  // Même vidéo et même logique de couleur que la home et que ClosedPreDrop.
  // Depuis le 20/09/2026 cette page ne charge plus background.mp4 (11 Mo).
  const { darkText } = useHomeVideo();

  return (
    <div
      className={`closedPlain closedPlain--onVideo${
        darkText ? " closedPlain--darkText" : ""
      }`}
    >

      <div className="closedPlain__center">
        <img
          className="closedVideo__logo"
          src={darkText ? logo : logoOnDark}
          alt="Ghetto Symphony"
        />

        <div className="closedVideo__title">site closed</div>
        <div className="closedVideo__sub">get notified for the next drop.</div>

        <div className="closedVideo__formWrap">
          <MailchimpSignup cta="notify me" />
        </div>
      </div>
    </div>
  );
}
